import { t } from "@lingui/macro";
import { Plus } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";
import { useNavigate } from "react-router-dom";

import { useFeatureGate } from "@/client/hooks/use-feature-gate";

import { BaseCard } from "./base-card";

export const CreateResumeCard = () => {
  const navigate = useNavigate();
  const { requirePlan } = useFeatureGate();

  return (
    <BaseCard
      onClick={() => {
        if (!requirePlan(t`Subscribe to a plan to start creating resumes.`)) return;
        navigate("/onboarding?new=1");
      }}
    >
      <Plus size={64} weight="thin" />

      <div
        className={cn(
          "absolute inset-x-0 bottom-0 z-10 flex flex-col justify-end space-y-0.5 p-4 pt-12",
          "bg-gradient-to-t from-background/80 to-transparent",
        )}
      >
        <h4 className="font-medium">{t`Build a resume`}</h4>
        <p className="text-xs opacity-75">{t`Tell us what you've done, or start blank`}</p>
      </div>
    </BaseCard>
  );
};
